import {
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  ReferenceInput,
  SelectInput,
  FileInput,
  FileField,
  useNotify,
  useRedirect,
  usePermissions,
  useDataProvider,
  useRecordContext,
} from "react-admin";

const UserGuideEditForm = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const dataProvider = useDataProvider();
  const record = useRecordContext();

  const handleSubmit = async (values) => {
    try {
      await dataProvider.update("user-guides", {
        id: record.id,
        data: values,
      });

      notify("User guide updated successfully ✅", {
        type: "success",
      });

      redirect("/user-guides");
    } catch (error) {
      notify(error.message || "Error updating user guide", {
        type: "error",
      });
    }
  };

  return (
    <SimpleForm onSubmit={handleSubmit}>
      <ReferenceInput source="course_id" reference="courses">
        <SelectInput optionText="course_name" />
      </ReferenceInput>

      <TextInput source="title" fullWidth />

      <FileInput source="file" label="Replace File" accept="*/*">
        <FileField source="src" title="title" />
      </FileInput>

      <BooleanInput source="is_active" />
    </SimpleForm>
  );
};

const UserGuideEdit = () => {
  const { permissions = [] } = usePermissions();

  if (
    !(
      permissions.includes("user-guides.edit") ||
      permissions.includes("user-guides.*") ||
      permissions.includes("*")
    )
  ) {
    return null;
  }

  return (
    <Edit title="Edit User Guide">
      <UserGuideEditForm />
    </Edit>
  );
};

export default UserGuideEdit;